import { useDispatch, useSelector } from "react-redux";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import ProjectInformationPage from "../../../Containers/ProjectInformationPage";
import { useEffect, useState } from "react";
import {
  GetSectoreInformationProject,
  SetSectoreInformationProject,
  ValidateSectoreInformationProject,
} from "../../../Redux/Reducers/ProjectInformationPage/SectoreInformationProject";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import UpdateSectoreInformationProject from "../../../Services/ProjectInformationPage/SectoreInformationProject/UpdateSectoreInformationProject";
import { SetExpectedProjectImpact } from "../../../Redux/Reducers/ProjectInformationPage/ExpectedProjectTargetGroupModule";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import loadConfig from "../../../Services/apiService";
import PopupAHSF from "../../../Components/PopupAHSF";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const SectoreInformationProjectUniquenessModule = () => {
  const dispatch = useDispatch();
  const AppGuid = useParams();
  const state = useSelector((state) => {
    return {
      SectoreInformationProject:
        state.SectoreInformationProject.SectoreInformationProject,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      loadingGetSectoreInformationProject:
        state.SectoreInformationProject.loadingGetSectoreInformationProject,
      SectoreInformationProjectValidate:
        state.SectoreInformationProject.SectoreInformationProjectValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });
  const navigate = useNavigate();
  // Initializing state for storing project sector data
  const [sectorProject, setSectorProject] = useState({
   
    ...state.SectoreInformationProject,
  });
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  const dataJson = async () => {
    //get data from main.json
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //console.log(jsonData, "jsonData");
  };


  //console.log(state.SectoreInformationProject, "SectoreInformationProject");
  // Fetching sector information project when the component mounts

  useEffect(() => {
    dispatch(
      GetSectoreInformationProject(
        state.ApplicationInformation.aI_ApplicationInformationId ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);

//to save data and after validation move to next page

  const SaveDataPage = async (withValidate) => {
    const saved = await UpdateSectoreInformationProject(
      state.SectoreInformationProject?.sO_sectorAndProjectOriginalityInfoId,
      sectorProject.competitorsIdentification,
      sectorProject.distinguishingFeaturesOfApplicant,
      sectorProject.reasonsSupportingFundingDecision,
      sectorProject.aI_ApplicationInformationId
    );
    if (withValidate == true && saved) {
      // If saved and validate is true, dispatch the validation action
      const validate = await dispatch(
        ValidateSectoreInformationProject(
          state.SectoreInformationProject.aI_ApplicationInformationId
        )
      );
      // after validation move to next page
      if (validate.payload.length === 0) {
        // If no validation errors, show success and navigate
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم حفظ المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        navigate("/grants/InformationProject/TeamPartnerships");
      } else {
        setisPopupOpenStatus(true);
      }
    }
  };

  // Handling updates to sector project data when loading is complete

  useEffect(() => {
    if (!state.loadingGetSectoreInformationProject) {
      setSectorProject({ ...state.SectoreInformationProject });
    }
  }, [state.loadingGetSectoreInformationProject]);

  //change on reduxer on any change on state sectorProject
  useEffect(() => {
    // Dispatching updated sector project data to Redux store
    dispatch(SetSectoreInformationProject({ ...sectorProject }));
  }, [sectorProject]);
  //console.log(state.SectoreInformationProject, "SectoreInformationProject");

  const shouldDisableFields =!(
   //[,]
// مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
state.ActiveRound ==
      state.ApplicationInformation?.aI_RoundYearId &&
    state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
    window.location.href.includes("manager") == false);
//render html after loading ends

  return (
    <>
      <ProjectInformationPage active={4} />
      {!state.loadingGetSectoreInformationProject ? (
        <>
          <SharedDiv
            showTitle={true}
            titleName="معلومات عن القطاع وأصالة المشروع"
            child={[
              <div className="form-grid">
                <TextAreaAHSF
                  fieldsName="IdentifyCompetitorsForTheProject"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.SectoreInformationProject?.competitorsIdentification
                  }
                  onChange={(e) => {
                    setSectorProject({
                      ...sectorProject,
                      competitorsIdentification: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.SectoreInformationProjectValidate
                      ? state.SectoreInformationProjectValidate.includes(
                          "IdentifyCompetitorsForTheProject"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="WhatDistinguishesTheApplicant"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.SectoreInformationProject
                      ?.distinguishingFeaturesOfApplicant
                  }
                  onChange={(e) => {
                    setSectorProject({
                      ...sectorProject,
                      distinguishingFeaturesOfApplicant: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.SectoreInformationProjectValidate
                      ? state.SectoreInformationProjectValidate.includes(
                          "WhatDistinguishesTheApplicant"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
                <TextAreaAHSF
                  fieldsName="ReasonsThatSupportTheFoundation'sDecision"
                  show={true}
                  disabled={shouldDisableFields}
                  defaultValue={
                    state.SectoreInformationProject
                      ?.reasonsSupportingFundingDecision
                  }
                  onChange={(e) => {
                    setSectorProject({
                      ...sectorProject,
                      reasonsSupportingFundingDecision: e.target.value,
                    });
                  }}
                  showValidationMessage={
                    state.SectoreInformationProjectValidate
                      ? state.SectoreInformationProjectValidate.includes(
                          "ReasonsThatSupportTheFoundation'sDecision"
                        )
                      : false
                  }
                  validationMessage="يرجى تعبئة هذا الحقل"
                />
              </div>,
            ]}
          />
          {!shouldDisableFields ? (
            <div className="containerButtonMAin">
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  SaveDataPage(false);
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "تم حفظ المعلومات بنجاح",
                    showConfirmButton: false,
                    timer: 1500,
                    // width: "500px",
                  });
                }}
                disabled={false}
                title={"حفظ"}
                text={"حفظ"}
                show={true}
              />
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  SaveDataPage(true);
                }}
                disabled={false}
                title={"التالي"}
                text={"التالي"}
                show={true}
              />
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingGetSectoreInformationProject} />
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)}
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة"
        componentBody={state.SectoreInformationProjectValidate}
      />
    </>
  );
};
export default SectoreInformationProjectUniquenessModule;
